window.addEventListener('load', () => {
  const marquees = document.querySelectorAll('.marquee');

  if (marquees && marquees.length > 0) {
    marquees.forEach((marquee) => {
      const clone = marquee.innerHTML;
      const firstElement = marquee.children[0];
      let i = 0;

      marquee.insertAdjacentHTML('beforeend', clone);
      marquee.insertAdjacentHTML('beforeend', clone);

      function animate() {
        firstElement.style.marginLeft = `-${i}px`;
        if (i > firstElement.clientWidth) {
          i = 0;
        }
        i += 1;
        requestAnimationFrame(animate);
      }

      requestAnimationFrame(animate);
    });
  }
});
